import { captureConsoleIntegration } from '@sentry/integrations';
import { breadcrumbsIntegration, browserTracingIntegration, init } from '@sentry/react';

import { ContextError } from 'errors/ContextError';

const SENTRY_SPA_DEV_DSN = 'https://beceeb4f99124421af31f137666ab6bc@sentry.interpals.net/6';
const SENTRY_SPA_PROD_DSN = 'https://bc48afb911e148d983d4c50eb0217557@sentry.interpals.net/7';

init({
    dsn: process.env.NODE_ENV === 'production' ? SENTRY_SPA_PROD_DSN : SENTRY_SPA_DEV_DSN,
    integrations: [
        browserTracingIntegration(),
        breadcrumbsIntegration({
            console: false,
            fetch: true,
        }),
        captureConsoleIntegration({ levels: ['error'] }),
    ],
    tracesSampleRate: 0.4,
    normalizeDepth: 10,

    // Extract additional custom context from errors if available
    beforeSend(event, hint) {
        const originalException = hint?.originalException;
        if (originalException instanceof ContextError) {
            event.extra = { context: originalException.context };
        }

        return event;
    },
});
